import Icon from '../Icon'

import {
  CheckboxContainer,
  HiddenCheckbox,
  StyledCheckbox,
  Label,
  Wrapper
} from './styles'

interface Props {
  isActive: boolean;
  onChange: () => void;
  label: string;
  name?: string;
}

export default function Checkbox({ isActive, onChange, label, name }: Props) {
  isActive = !isActive;
  return (
    <Wrapper onClick={onChange}>
      <CheckboxContainer>
        <HiddenCheckbox {...(isActive ? {checked: 'checked'} : {})} name={name} />
        <StyledCheckbox {...(isActive ? {checked: 'checked'} : {})} name={name} >
          {!isActive && <Icon name="check" loop={false} autoplay={false} style={{opacity: isActive ? 0 : 1, translate: '.3s'}} />}
        </StyledCheckbox>
      </CheckboxContainer>
      <Label isActive={isActive} style={{ marginLeft: `1.2rem` }}>{label}</Label>
    </Wrapper>
  );
}